import AreaSegment from '../area-chart/area-segment';

class RadarAreaSegment extends AreaSegment {
    fillToAxes() {}
}

export default RadarAreaSegment;